.spinner {
  display: inline-flex;
  width: 1em;
  height: 1em;
  flex: none;
}

.svg {
  width: 100%;
  height: 100%;
  animation: spin 640ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}

/* The base stylesheet cancels animation durations globally under reduced
   motion, which would freeze the arc mid-rotation and read as a broken image.
   Given the ring is drawn underneath at low opacity, hiding the arc leaves a
   complete circle, and a slow opacity pulse still says "working" — that pulse
   is re-enabled here because it is the accessible substitute, not decoration. */
@media (prefers-reduced-motion: reduce) {
  .arc {
    display: none;
  }

  .svg {
    animation: none;
    opacity: 0.6;
  }

  .spinner {
    animation: pulse 1.4s ease-in-out infinite !important;
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.45;
  }
  50% {
    opacity: 1;
  }
}
